/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js";
import { setApplicationLocalStorageItem } from "../../helpers";
import store from "../store";
import { performFetch } from '../../helpers.js'

export default {
  // addItem({ commit }, item) {
  //   return new Promise((resolve, reject) => {
  //     axios.post("/api/data-list/products/", {item: item})
  //       .then((response) => {
  //         commit('ADD_ITEM', Object.assign(item, {id: response.data.id}))
  //         resolve(response)
  //       })
  //       .catch((error) => { reject(error) })
  //   })
  // },
  fetchUsers({ commit }) {
    return new Promise(async (resolve, reject) => {
      // fetch(store.state.auth.api_url, {
      //   method: "POST", headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: "get_application_users",
      //     parameters: {
      //       application_token: store.state.auth.app_token,
      //       session_token: store.state.auth.token
      //     }
      //   })
      // })
      await performFetch(store.state.auth.api_url, {
        command: "get_application_users",
        parameters: {
          application_token: store.state.auth.app_token,
          session_token: store.state.auth.token
        }
      })
      .then(async response => {
        // commit('SET_USERS', response.data)
        // resolve(response)
        if (response.status === 200) {
          await response.json().then(async response => {
            response.users.forEach((item, key) => {
              item.avatar = item.photo;
              return item;
            });
            response.users = response.users.filter(el => el.active === true);

            commit("SET_USERS", response.users);
            resolve(response);
          });
        } else if (response.status === 401) {
          setApplicationLocalStorageItem(
            "lastUrl",
            btoa(window.location.pathname)
          );
          store.dispatch("auth/signOut");
        }
      });
      // .catch((error) => { reject(error) })

      // axios.get('/api/user-management/users')
      //   .then((response) => {
      //     console.log(response.data)
      //     commit('SET_USERS', response.data)
      //     resolve(response)
      //   })
      //   .catch((error) => { reject(error) })
    });
  },
  fetchUserProfile({ commit, dispatch }, payload) {
    return new Promise(async (resolve, reject) => {
      // fetch(payload.apiUrl, {
      //   method: "POST", headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: "get_user_profile",
      //     parameters: {
      //       application_token: payload.appToken,
      //       session_token: payload.userSession
      //     }
      //   })
      // })
      await performFetch(payload.apiUrl, {
        command: "get_user_profile",
        parameters: {
          application_token: payload.appToken,
          session_token: payload.userSession
        }
      })
        .then(async response => {
          if (response.status === 200) {
            await response.json().then(async response => {
              response.profile.contacts = [
                response.profile.contact_by_email ? "email" : "",
                response.profile.contact_by_phone ? "phone" : "",
                response.profile.contact_by_message ? "message" : ""
              ];
              resolve(response.profile);
            });
          } else if (response.status == 401) {
            setApplicationLocalStorageItem(
              "lastUrl",
              btoa(window.location.pathname)
            );
            store.dispatch("auth/signOut");
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  setUserProfile({ commit }, payload) {
    commit("SET_USER_PROFILE", payload);
  },
  setcalendars({ commit }, payload) {
    commit("SET_CALENDAR_LIST", payload);
  },
  async getUserCalendars({ commit }) {
    // await fetch(`${store.state.auth.api_url}`, {
    //   method: "POST", headers: {"Content-Type": "application/json"},
    //   body: JSON.stringify({
    //     command: "get_calendar_data",
    //     parameters: {
    //       application_token: store.state.auth.app_token,
    //       session_token: store.state.auth.token
    //     }
    //   })
    // })
    await performFetch(`${store.state.auth.api_url}`, {
      command: "get_calendar_data",
      parameters: {
        application_token: store.state.auth.app_token,
        session_token: store.state.auth.token
      }
    })
      .then(async response => {
        if (response.status === 200) {
          await response.json().then(responseData => {
            if (responseData.calendars.length > 0) {
              const userCalendars = [];

              responseData.calendars.forEach(item => {
                userCalendars.push({
                  calendarHash: item.hash,
                  calendarName: item.title,
                  calendarView: item.user_view
                });
              });

              commit("SET_CALENDARS_LIST", userCalendars);
            }
          });
        } else if (response.status === 401) {
          setApplicationLocalStorageItem(
            "lastUrl",
            btoa(window.location.pathname)
          );
          store.dispatch("auth/signOut");
        }
      })
      .catch(e => {
        console.log(e);
        throw new Error(e.message);
      });
  },
  // fetchUser (context, userId) {
  //   return new Promise((resolve, reject) => {
  //     axios.get(`/api/user-management/users/${userId}`)
  //       .then((response) => {
  //         console.log(response)
  //         resolve(response)
  //       })
  //       .catch((error) => { reject(error) })
  //   })
  // },
  fetchUser({ commit }, userHash) {
    return new Promise(async (resolve, reject) => {
      // await fetch(store.state.auth.api_url, {
      //   method: "POST", headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: "get_application_user_detail",
      //     parameters: {
      //       application_token: store.state.auth.app_token,
      //       session_token: store.state.auth.token,
      //       user_hash: userHash
      //     }
      //   })
      // })
      await performFetch(store.state.auth.api_url, {
        command: "get_application_user_detail",
        parameters: {
          application_token: store.state.auth.app_token,
          session_token: store.state.auth.token,
          user_hash: userHash
        }
      })
        .then(async response => {
          if (response.status === 200) {
            await response.json().then(async response => {
              commit("setUserEditName", response.user.name);
              commit("setUserEditEmail", response.user.email);
              commit("setUserEditMobile", response.user.mobile);
              commit("setUserEditRole", response.user.role.hash);
              commit("setUserEditRoleObject", response.user.role);
              commit("setUserEditStatusId", response.user.status_id);
              commit("setUserEditIsAdmin", response.user.is_admin);
              commit("setUserEditExternalUser", response.user.external_user);
              commit("setUserEditLanguages", response.user.languages);
              resolve(response.user);
            });
          } else if (response.status == 401) {
            setApplicationLocalStorageItem(
              "lastUrl",
              btoa(window.location.pathname)
            );
            store.dispatch("auth/signOut");
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  validBase64({}, str) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        if (str) {
          if (str.substring(0, 4) !== "http") {
            resolve(/[A-Za-z0-9+/=]/.test(str));
          } else {
            resolve(false);
          }
        }
      }, 300);
    });
  },
  async saveChanges({ commit, dispatch, state }, payload) {
    let is_base64 = false;

    if (payload.userProfile.photo) {
      is_base64 = await dispatch("validBase64", payload.userProfile.photo).then(
        response => {
          return response;
        }
      );
    }

    if (!is_base64 && payload.userProfile.photo !== null) {
      const toDataURL = url =>
        fetch(url)
          .then(response => response.blob())
          .then(
            blob =>
              new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
              })
          );

      const photo_base64 = await toDataURL(payload.userProfile.photo).then(
        dataUrl => {
          return dataUrl;
        }
      );

      commit("SET_PHOTO", photo_base64);
    } else if (is_base64) {
      commit("SET_PHOTO", payload.userProfile.photo);
    } else {
      commit("SET_PHOTO", null);
    }

    return new Promise(async (resolve, reject) => {
      // fetch(payload.apiUrl, {
      //   method: "POST", headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: "update_user_profile",
      //     parameters: {
      //       application_token: store.state.auth.app_token,
      //       session_token: store.state.auth.token,
      //       profile: state.userProfile
      //     }
      //   })
      // })
      await performFetch(payload.apiUrl, {
        command: "update_user_profile",
        parameters: {
          application_token: store.state.auth.app_token,
          session_token: store.state.auth.token,
          profile: state.userProfile
        }
      })
        .then(async response => {
          if (response.status === 200) {
            await response.json().then(async response => {
              resolve(response);
            });
          } else if (response.status == 401) {
            setApplicationLocalStorageItem(
              "lastUrl",
              btoa(window.location.pathname)
            );
            store.dispatch("auth/signOut");
          } else {
            reject(Error("Internal Server Error"));
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  removeRecord({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/user-management/users/${userId}`)
        .then(response => {
          commit("REMOVE_RECORD", userId);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};
